import { render } from "./mesasvisualizar.vue?vue&type=template&id=bb2b61d0&scoped=true"
import script from "./mesasvisualizar.vue?vue&type=script&lang=js"
export * from "./mesasvisualizar.vue?vue&type=script&lang=js"

import "./mesasvisualizar.vue?vue&type=style&index=0&id=bb2b61d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb2b61d0"]])

export default __exports__